module.exports = __webpack_public_path__ + "static/media/landelijk.6d36a357.jpg";